// extracted by mini-css-extract-plugin
export var askAiIcon = "_mi-9";
export var container = "_mi-0";
export var groupSeparator = "_mi-a";
export var highlight = "_mi-4";
export var resultIcon = "_mi-5";
export var resultItem = "_mi-7";
export var resultSubtitle = "_mi-3";
export var resultTitle = "_mi-2";
export var resultsList = "_mi-1";
export var searchGroup = "_mi-6";
export var selected = "_mi-8";